import { registerPlugin } from '@capacitor/core';
import type { EscPosPrinterPlugin } from './definitions';

export type {
  BluetoothEscPosDevice,
  EscPosPrintRawOptions,
  EscPosPrintRawResult,
  EscPosPrinterPlugin,
  UsbEscPosDevice,
} from './definitions';

export const EscPosPrinter = registerPlugin<EscPosPrinterPlugin>('EscPosPrinter', {
  web: () => import('./escpos-printer.web').then((m) => new m.EscPosPrinterWeb()),
});
